exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".register-blocks .form-group {\n  margin-bottom: 25px;\n}\n.register-blocks .form-group .form-control.error {\n  border: 1px solid #d9534f;\n}\n", ""]);

// exports
